import dayjs from 'dayjs'

const ISO_DATE = 'YYYY-MM-DD'

export function mondayOf(dateStr) {
  const d = dateStr ? dayjs(dateStr) : dayjs()
  const day = d.day() // 0=Sun,1=Mon,...
  const diff = day === 0 ? -6 : 1 - day
  return d.add(diff, 'day').format(ISO_DATE)
}

const DAY_NAME_TO_INDEX = {
  sunday: 0,
  monday: 1,
  tuesday: 2,
  wednesday: 3,
  thursday: 4,
  friday: 5,
  saturday: 6,
}

// Maps a lowercase weekday name (e.g. the API's `start_day`) to the JS
// getDay() index startDayOf() expects, or null when it isn't a weekday name.
export function dayNameToIndex(name) {
  if (!name) return null
  const idx = DAY_NAME_TO_INDEX[String(name).toLowerCase()]
  return idx == null ? null : idx
}

// Maps the API's lowercase `start_day` name (e.g. "monday" on the
// /timesheet-settings payload) to the JS getDay() index startDayOf() expects.
// Defaults to Monday when settings are missing/unavailable.
export function settingsStartDay(settings) {
  if (!settings || !settings.start_day) return 1
  const idx = dayNameToIndex(settings.start_day)
  return idx == null ? 1 : idx
}

// startDay uses JS getDay() convention: 0=Sun, 1=Mon, ..., 6=Sat
export function startDayOf(dateStr, startDay) {
  const d = dateStr ? dayjs(dateStr) : dayjs()
  const diff = (d.day() - startDay + 7) % 7
  return d.subtract(diff, 'day').format(ISO_DATE)
}

export function weekDates(mondayStr) {
  const start = dayjs(mondayStr)
  return Array.from({ length: 7 }, (_, i) =>
    start.add(i, 'day').format(ISO_DATE),
  )
}

export function addWeeks(mondayStr, n) {
  return dayjs(mondayStr)
    .add(n * 7, 'day')
    .format(ISO_DATE)
}

export function addDays(dateStr, n) {
  return dayjs(dateStr).add(n, 'day').format(ISO_DATE)
}

// Inclusive day count between two ISO dates (same day = 1).
export function daySpan(fromStr, toStr) {
  return dayjs(toStr).diff(dayjs(fromStr), 'day') + 1
}

export function formatWeekLabel(mondayStr) {
  return `Week commencing ${dayjs(mondayStr).format('D MMM YYYY')}`
}

export function formatDayHeader(dateStr) {
  const d = dayjs(dateStr)
  return { weekday: d.format('ddd'), dayLabel: d.format('D MMM') }
}
